<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">中转单位</font>
          <span>临时中转</span>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item" @click="searchGovAuthStatus()">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>单位数量</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">家</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li style="width: 280px">
          <Input size="small" v-model="searchMap.keywordA" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="name">单位名称</Option>
              <Option value="addressFull">所在地区</Option>
            </Select>
          </Input>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small">导出</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <div class="REWwater">临时中转单位</div>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="name">
            <span>{{ row.name }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="orgKind">
            <span>{{ $CVALUE("orgKind", row.orgKind) }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="name">
            <span class="FTC4 oe1" style="font-size: 17px; font-weight: 700">{{ row.name }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="jieshouGarbageNumberTotal">
            <span>{{ row.jieshouGarbageNumberTotal || 0 }}m³</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="jieshouGarbageCountTotal">
            <span>{{ row.jieshouGarbageCountTotal || 0 }}次</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangGarbageNumberTotal">
            <span>{{ row.paifangGarbageNumberTotal || 0 }}m³</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangGarbageCountTotal">
            <span>{{ row.paifangGarbageCountTotal || 0 }}次</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="decryptToId">
            <span> {{ $decryptToId(row.id) }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <QHexcelDownload ref="QHexcelDownload"></QHexcelDownload>
      <detailed ref="detailed" @success="getList()" :scene="scene"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
import QHexcelDownload from "@/layout/component/QHexcelDownload/QHexcelDownload";
export default {
  components: {
    detailed,
    QHexcelDownload,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      selectedRowsMore: [],
      columns: this.$colFilter([
        {
          type: "selection",
          width: 40,
          align: "center",
        },
        {
          title: "中转单位",
          key: "name",
          minWidth: 400,
          slot: "name",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "单位类型",
          slot: "orgKind",
          width: 80,
          align: "center",
        },
        {
          title: "接收总方",
          slot: "jieshouGarbageNumberTotal",
          width: 120,
          align: "center",
        },
        {
          title: "接收运次",
          slot: "jieshouGarbageCountTotal",
          width: 120,
          align: "center",
        },
        {
          title: "排放总方",
          slot: "paifangGarbageNumberTotal",
          width: 120,
          align: "center",
        },
        {
          title: "排放运次",
          slot: "paifangGarbageCountTotal",
          width: 120,
          align: "center",
        },
        {
          title: "所属城市",
          key: "cityName",
          width: 120,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "所属区县",
          key: "districtName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "所属街道",
          key: "streetName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "联系姓名",
          key: "contactName",
          width: 100,
          align: "center",
        },
        {
          title: "联系电话",
          key: "contactTel",
          width: 110,
          align: "center",
        },
        {
          title: "联单查询码",
          key: "decryptToId",
          width: 100,
          align: "center",
          slot: "decryptToId",
        },
        {
          title: "开通时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 60,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "name",
        keywordA: "",
        govAuthStatus: "",
        orgKind: "200,1000",
        pageNo: 1,
        pageSize: 25,
      },
      searchMapInt: {},
      total: {},
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
      scene: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.searchMapInt = this.$copyObj(this.searchMap);
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap = this.$copyObj(this.searchMapInt);
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var https = {
        type: "isPagelist",
        api: this.$api.getOrglinshizhongzhuanList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 导出excel
    // +----------------------------------------------------------------------
    uploadExcel() {
      var that = this;
      var title = "红白蓝平台临时中转单位";
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var searchMap=this.$copyObj(this.searchMap);
      searchMap['ids']=this.$copyObj(this.selectedRows);
      this.$refs.QHexcelDownload.hiPop({
        title: title,
        api: that.$api.getOrglinshizhongzhuanExcelList,
        searchMap: searchMap,
        columns: this.$ExcelDownloadConfig["headOrgLinshizhongzhuan"],
      });
    },

    // +----------------------------------------------------------------------
    // | 执行govAuthStatus搜索请求
    // +----------------------------------------------------------------------
    searchGovAuthStatus(govAuthStatus) {
      this.searchMap.govAuthStatus = govAuthStatus;
      this.search();
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
